module.exports = __webpack_public_path__ + "media/cn.02c229de.svg";